module.exports = __webpack_public_path__ + "img/TimelineDefault.a934eb68.svg";